import React from 'react';
import {useForm, Controller} from 'react-hook-form';
import {
  TextField,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Rating,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Stack,
  CircularProgress,
  Link,
} from '@mui/material';
import DateFormat from '../datepicker/DateFormat';
import {styled} from '@mui/material/styles';
import {useSubmit} from './hooks/useSubmit';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import {useParams} from 'react-router-dom';
import {useNavigate} from 'react-router-dom';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {useUserInfo} from '../userInfo/hooks/useUserInfo';
import {getTimesOutsideRange, getDatesWithinRange} from '../Service';

const DynamicForm = ({form, product}) => {
  console.log('form:', form);
  console.log('Product:', product);
  const {control, handleSubmit, reset} = useForm();
  const {submit} = useSubmit();
  const [open, setOpen] = React.useState(false);
  const {id} = useParams();
  const navigate = useNavigate();
  const [cgvError, setCgvError] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const {mode} = useDarkMode();
  const {profil} = useUserInfo();
  const StyledRating = styled(Rating)({
    '& .MuiRating-iconFilled': {
      color: '#faaf00',
    },
    '& .MuiRating-iconHover': {
      color: '#faaf00',
    },
    '& .MuiRating-iconEmpty': {
      color: mode.settings.textColor3,
    },
  });
  const onSubmit = async data => {
    console.log('Form Data:', data);
    if (!data.cgv) {
      setCgvError(true);
      return;
    }
    setIsLoading(true);

    const formatedData = {};

    console.log('data', data);
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const newKey = key.split('/')[1];
        if (
          formatedData.hasOwnProperty(newKey) &&
          key.split('/')[0] === 'address'
        ) {
          formatedData['address'] = `${formatedData[newKey]};${data[key]}`;
          formatedData[newKey] = `${formatedData[newKey]};${data[key]}`;
        } else if (key.split('/')[0] === 'address') {
          formatedData['address'] = data[key];
          formatedData[newKey] = data[key];
        } else {
          formatedData[newKey] = data[key];
        }
      }
    }

    console.log('formatedData', formatedData);
    const submited = await submit(
      formatedData,
      id,
      product.payment_type,
      product.price,
    );
    console.log('submited:', submited);
    if (submited) {
      setIsLoading(false);
      reset();
      navigate('/order-history');
    } else {
      setIsLoading(false);
      setOpen(true);
    }
  };

  if (!profil) {
    return <CircularProgress />;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          {'Une erreur est survenue lors de la validation de votre commande'}
        </DialogTitle>
        <DialogActions>
          <Button
            className="buttonOhs"
            onClick={() => setOpen(false)}
            autoFocus
            aria-label={'Accepter'}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      {form &&
        form.fields.map(field => (
          <FormControl key={field.id} fullWidth margin="normal">
            {field.options.type === 'text' && (
              <Controller
                name={field.name + '/' + field.id}
                control={control}
                defaultValue={
                  field.options.label === 'Nom'
                    ? profil.last_name
                    : field.options.label === 'Prénom'
                    ? profil.first_name
                    : field.options.label === 'Adresse de livraison'
                    ? `${profil.address ? profil.address : ''} ${
                        profil.postalCode ? profil.postalCode : ''
                      } ${profil.city ? profil.city : ''}`
                    : ''
                }
                render={({field: controllerField}) => (
                  <TextField
                    {...controllerField}
                    label={field.options.label}
                    required={field.options.required == 'on'}
                    sx={{background: mode.settings.inputBackgroundColor}}
                    InputProps={{
                      inputProps: {style: {color: mode.settings.textColor3}},
                    }}
                    InputLabelProps={{style: {color: mode.settings.textColor3}}}
                  />
                )}
              />
            )}
            {field.options.type === 'address' && (
              <Stack direction={'column'} gap={2}>
                <Controller
                  name={'address' + '/' + field.id + '/address'}
                  control={control}
                  defaultValue={profil.address}
                  render={({field: controllerField}) => (
                    <TextField
                      {...controllerField}
                      label={field.options.label}
                      required={true}
                      sx={{background: mode.settings.inputBackgroundColor}}
                      InputProps={{
                        inputProps: {style: {color: mode.settings.textColor3}},
                      }}
                      InputLabelProps={{
                        style: {color: mode.settings.textColor3},
                      }}
                    />
                  )}
                />
                <Controller
                  name={'address' + '/' + field.id + '/city'}
                  control={control}
                  defaultValue={profil.city}
                  render={({field: controllerField}) => (
                    <TextField
                      {...controllerField}
                      label={'Ville'}
                      required={true}
                      sx={{background: mode.settings.inputBackgroundColor}}
                      InputProps={{
                        inputProps: {style: {color: mode.settings.textColor3}},
                      }}
                      InputLabelProps={{
                        style: {color: mode.settings.textColor3},
                      }}
                    />
                  )}
                />
                <Controller
                  name={'address' + '/' + field.id + '/postalCode'}
                  control={control}
                  defaultValue={profil.postalCode}
                  render={({field: controllerField}) => (
                    <TextField
                      {...controllerField}
                      label={'Code Postal'}
                      required={true}
                      sx={{background: mode.settings.inputBackgroundColor}}
                      InputProps={{
                        inputProps: {style: {color: mode.settings.textColor3}},
                      }}
                      InputLabelProps={{
                        style: {color: mode.settings.textColor3},
                      }}
                    />
                  )}
                />
              </Stack>
            )}
            {field.options.type === 'textArea' && (
              <Controller
                name={field.name + '/' + field.id}
                control={control}
                defaultValue=""
                render={({field: controllerField}) => (
                  <TextField
                    {...controllerField}
                    label={field.options.label}
                    required={field.options.required == 'on'}
                    multiline={true}
                    rows={3}
                    maxRows={6}
                    sx={{background: mode.settings.inputBackgroundColor}}
                    InputProps={{
                      inputProps: {style: {color: mode.settings.textColor3}},
                    }}
                    InputLabelProps={{style: {color: mode.settings.textColor3}}}
                  />
                )}
              />
            )}
            {field.options.type === 'evaluate' && (
              <Controller
                name={field.name + '/' + field.id}
                control={control}
                defaultValue=""
                render={({field: controllerField}) => (
                  <div>
                    <Typography sx={{color: mode.settings.textColor3}}>
                      {field.options.label}
                    </Typography>
                    <StyledRating
                      {...controllerField}
                      value={controllerField.value}
                      onChange={(event, newValue) => {
                        controllerField.onChange(newValue);
                      }}
                      sx={{fontSize: 50}}
                    />
                  </div>
                )}
              />
            )}
            {field.options.type === 'dateTime' && (
              <Stack gap={'10px'}>
                <Typography
                  variant={'subtitle1'}
                  color={mode.settings.textColor3}>
                  {field.options.label}
                </Typography>
                <Controller
                  name={field.name + '/' + field.id}
                  control={control}
                  defaultValue=""
                  render={({field: controllerField}) => (
                    <DateFormat
                      label={'Date'}
                      startDate={controllerField.value}
                      setStartDate={controllerField.onChange}
                    />
                  )}
                />
              </Stack>
            )}
            {field.options.type === 'rdv' && (
              <Stack gap={'10px'}>
                <Typography
                  variant={'subtitle1'}
                  color={mode.settings.textColor3}>
                  {field.options.label}
                </Typography>
                <Controller
                  name={field.name + '/' + field.id}
                  control={control}
                  defaultValue=""
                  render={({field: controllerField}) => (
                    <DateFormat
                      label={'Date'}
                      startDate={controllerField.value}
                      setStartDate={controllerField.onChange}
                      //includeDateInterval={[new Date(field.options.bookingStart), field.options.bookingEnd]}
                      includeDates={getDatesWithinRange(
                        field.options.bookingStart,
                        field.options.bookingEnd,
                        field.options.availableDays,
                      )}
                      excludeTimes={getTimesOutsideRange(
                        field.options.startHour,
                        field.options.endHour,
                      )}
                    />
                  )}
                />
              </Stack>
            )}
            {field.options.type === 'list' && (
              <FormGroup>
                <Typography
                  variant={'subtitle1'}
                  color={mode.settings.textColor3}>
                  {field.options.label}
                </Typography>
                {field.options.choices.split(';').map((option, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Controller
                        name={`${field.name}/${field.id}[${index}]`}
                        control={control}
                        defaultValue={false}
                        render={({field: controllerField}) => (
                          <Checkbox
                            {...controllerField}
                            value={option}
                            checked={controllerField.value === option}
                            onChange={event => {
                              controllerField.onChange(
                                event.target.checked ? option : false,
                              );
                            }}
                            style={{color: mode.settings.textColor3}}
                          />
                        )}
                      />
                    }
                    label={option}
                    sx={{color: mode.settings.textColor3}}
                  />
                ))}
              </FormGroup>
            )}
            {/* Add more field types as needed */}
          </FormControl>
        ))}
      <FormGroup>
        <FormControlLabel
          control={
            <Controller
              name={`cgv`}
              control={control}
              defaultValue={false}
              render={({field: controllerField}) => (
                <Checkbox
                  {...controllerField}
                  checked={controllerField.value}
                  onChange={event =>
                    controllerField.onChange(event.target.checked)
                  }
                  style={{color: mode.settings.textColor3}}
                />
              )}
            />
          }
          label={
            <Typography>
              J'accepte les CGV du vendeur.
              <Link
                href={product.cgvlink}
                target="_blank"
                rel="noopener noreferrer">
                {' '}
                Voir les CGV
              </Link>
            </Typography>
          }
          sx={{color: mode.settings.textColor3}}
        />
        {cgvError && (
          <Typography
            variant={'subtitle3'}
            color={'error'}
            sx={{marginBottom: '10px'}}>
            Vous devez accepter les CGV pour continuer
          </Typography>
        )}
      </FormGroup>
      {!isLoading && (
        <Button type="submit" variant="contained" color="primary">
          {product.payment_type == 4 ? (
            <Typography variant={'subtitle3'}>Demander un devis</Typography>
          ) : (
            <Typography variant={'subtitle3'}>Valider ma commande</Typography>
          )}
        </Button>
      )}
      {isLoading && (
        <Button disabled={true} variant="contained" color="primary">
          {product.payment_type == 4
            ? 'Demander un devis'
            : 'Valider ma commande'}
        </Button>
      )}
    </form>
  );
};

export default DynamicForm;
